var chunkToChildrenMap = {
	"1942": [
		2633,
		9505,
		9967,
		1574,
		7509,
		4575,
		3215,
		6967,
		6221
	],
	"2180": [
		7987,
		9455
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };